<template>
  <div class="sales-summary">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4"></div>

          <div class="col-md-4">
            <div class="top-navbar-center">
              Team Arrival & Departure

              <small class="last-updated">Last updated on {{ latestUpdateTime }}</small>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-right">
              <button
                class="btn btn-ecdc"
                @click="$router.push({ name: 'teamArrivalDetails' })"
              >
                Check In Details
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="summary-list row row-cols-7">
        <div
          :key="`summary-key-${key}`"
          v-for="(dailyRecord, key) in dailyData"
          class="col"
        >
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                {{ `DAY ${dailyRecord.day}/${dailyRecord.month}` }}
                <small>
                  {{ `WEEK ${dailyRecord.week_num}` }}
                </small>
              </h3>

              <div class="figure">
                {{ dailyRecord.number }}
                <small>Team Check In</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="data-card-list row row-cols-xl-3 row-cols-md-2 row-cols-1 mt-4">
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  TOTAL TEAM CHECK IN
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getTeamArrivalChart"
                  v-model="chartDateDropdown"
                >
                  <option value="year">YEAR</option>
                  <option value="month">MONTH</option>
                  <option value="week">WEEK</option>
                </select>
              </div>
            </div>
            <app-line-chart
              :chart-data="chartData"
              :options="chartOption"
              :height="250"
            ></app-line-chart>
          </div>
        </div>

        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  Active Users By Area
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getArrivalCheckInArea"
                  v-model="arrivalAreaDate"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in weeklyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <h4 class="section-title">Top 5</h4>

                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in topWeeklyCheckInAreas"
                >
                  <dt class="col-8">
                    {{ (index += 1) }}. {{ data.area.name || "" }}
                  </dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6 mt-4 mt-sm-0 mt-lg-4 mt-xl-0">
                <h4 class="section-title">Least 5</h4>

                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in worstWeeklyCheckInAreas"
                >
                  <dt class="col-8">
                    {{ (index += 1) }}. {{ data.area.name || "" }}
                  </dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  TEAM STATISTICS
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getArrivalTopTeams"
                  v-model="teamArrivalAreaDate"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in monthlyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <h4 class="section-title">Top 10 CHECK IN</h4>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in monthlyTopCheckInTeam.slice(0, 5)"
                >
                  <dt class="col-1">{{ (index += 1) }}.</dt>
                  <dt class="col-7">
                    {{ data.team.name || "" }}
                  </dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6" v-if="monthlyTopCheckInTeam.count > 5">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in monthlyTopCheckInTeam.slice(5, 10)"
                >
                  <dt class="col-1">{{ (index += 6) }}.</dt>
                  <dt class="col-7">
                    {{ data.team.name || "" }}
                  </dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-loader v-show="isLoading"></app-loader>
  </div>
</template>

<script>
import {
  getDashboardDate,
  getTeamArrivalAndDepartureSummary,
  getTeamArrivalAndDepartureByCategorySummary
} from "../api";
import LineChart from "./chart/LineChart.vue";
import { getProj } from "../helpers";
import Loader from "./Loader";

export default {
  components: {
    appLineChart: LineChart,
    appLoader: Loader
  },

  data() {
    const moment = require("moment");
    const thisMonday = moment()
      .day("Monday")
      .format("YYYY-MM-DD");
    const startOfMonth = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    return {
      latestUpdateTime: new Date().getDate() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getFullYear(),
      isLoading: true,
      projectId: getProj()["projId"],
      weeklyDateFilter: [],
      monthlyDateFilter: [],
      dailyData: [],
      chartDateDropdown: "month",
      chartData: {},
      chartOption: {},
      arrivalAreaDate: thisMonday,
      topWeeklyCheckInAreas: [],
      worstWeeklyCheckInAreas: [],
      teamArrivalAreaDate: startOfMonth,
      monthlyTopCheckInTeam: []
    };
  },
  async mounted() {
    await this.getDate();
    await this.getTeamArrivalSummaryData();
    await this.getTeamArrivalChart();
    await this.getArrivalCheckInArea();
    await this.getArrivalTopTeams();
    this.isLoading = false;
  },
  methods: {
    async getDate() {
      try {
        const weeklyParams = { dateType: "week" };
        const monthlyParams = { dateType: "month" };
        const result = await Promise.all([
          getDashboardDate(weeklyParams),
          getDashboardDate(monthlyParams)
        ]);
        this.weeklyDateFilter = result[0].data.data.dates;
        this.monthlyDateFilter = result[1].data.data.dates;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getTeamArrivalSummaryData() {
      try {
        const params = { projectId: this.projectId, dateType: "day" };
        const result = await getTeamArrivalAndDepartureSummary(params);
        this.dailyData = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getTeamArrivalChart() {
      try {
        let result = await getTeamArrivalAndDepartureSummary({
          projectId: this.projectId,
          dateType: this.chartDateDropdown
        });
        this.filterChart(result.data.data.statistics);
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getArrivalCheckInArea() {
      try {
        let result = await getTeamArrivalAndDepartureByCategorySummary({
          projectId: this.projectId,
          category: "area",
          date: this.arrivalAreaDate
        });
        this.topWeeklyCheckInAreas = result.data.data.statistics.top;
        this.worstWeeklyCheckInAreas = result.data.data.statistics.worst;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getArrivalTopTeams() {
      try {
        let result = await getTeamArrivalAndDepartureByCategorySummary({
          projectId: this.projectId,
          category: "team",
          date: this.teamArrivalAreaDate
        });
        this.monthlyTopCheckInTeam = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    filterChart(chartData) {
      let labels = [];
      let data = [];

      chartData.forEach(item => {
        if (this.chartDateDropdown == "week")
          labels.push(`WEEK ${item.week_num}`);
        if (this.chartDateDropdown == "month") labels.push(item.month);
        if (this.chartDateDropdown == "year") labels.push(item.year);
        data.push(item.number);
      });

      this.chartData = {
        labels: labels,
        datasets: [
          {
            label: "TOTAL TEAM CHECK IN",
            backgroundColor: "rgba(0, 0, 0, 0)",
            borderColor: "#FDCD08",
            borderWidth: 2,
            lineTension: 0,
            data: data
          }
        ]
      };
    }
  }
};
</script>
